
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"none","viewBox":"0 0 660 345","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M656 6H0V2h660v343h-4V6z","fill":"#484848"}}),_c('path',{attrs:{"fill":"#C6EED1","d":"M653 0h7v6.372h-7zM0 0h4v6.372H0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M409 160H0v-4h413v189h-4V160zM0 264h193v81h-4v-77H0v-4z","fill":"#30C07C"}})])
          )
        }
      }
    